import { useParams } from "react-router-dom";

import { useLoadData } from "../../../../hooks/useLoadData";
import { ApiResponse } from "../../../../models/api-response";
import { Employee } from "../../../../models/masters/employee";
import { SaveEmployeeComponent } from "./save-employee.component";
import { SiTrackPage } from "../../../../components/si-track-page";
import { usersApiKeyStore } from "../../../../api/users-api-key-store";
import { editEmployeeFormSchema } from "./edit-employee-form.schema";
import { useEffect, useState } from "react";

export const EditEmployeePage = () => {
    const { id } = useParams();
    const [employeeData, setEmployeeData] = useState<any>();
    const { isLoading, data } = useLoadData<ApiResponse<Employee>>(usersApiKeyStore.getUserByID(Number(id)));

    useEffect(() => {
        if (data?.data) {
            const userSkillsets = data?.data?.userSkillsets || [];

            const formattedSkillsets = userSkillsets?.map(
                ({
                    skillsetAssociatedServiceGroupID,
                    associatedServiceGroupName,
                    associatedServiceGroupCode, // intentionally ignored
                    ...rest
                }: any) => ({
                    ...rest,
                    skillsetAssociatedServiceGroup: {
                        skillsetAssociatedServiceGroupID,
                        associatedServiceGroupName,
                    },
                })
            );

            setEmployeeData({
                ...data.data,
                userSkillsets: formattedSkillsets,
            });
        }
    }, [data]);

    return (
        <SiTrackPage title="Edit Employee" isLoading={isLoading}>
            {employeeData && <SaveEmployeeComponent employee={employeeData} yupSchema={editEmployeeFormSchema} />}
        </SiTrackPage>
    );
}